import React from 'react'

import { Checkbox } from 'rsuite'

export default function ProductSearchSaledFilter ({
  onChange,
  value,
  ...props
}: any) {
  const handleChange = (_value: any, checked: boolean) => {
    onChange(checked)
  }

  return <Checkbox {...props} checked={value} onChange={handleChange} />
}
